const X_class = 'x';
const O_class = 'o';

let cellElements = document.querySelectorAll('[data-cell]');
const board = document.getElementById('board');
const winningMessageTxt = document.querySelector('[data-winning-message-text]');
const winningMessageElement = document.getElementById('winningMessage');
const boardHeightInput = document.getElementById('boardHeight');
let boardHeight = boardHeightInput.value;
const boardWidthInput = document.getElementById('boardWidth');
let boardWidth = boardWidthInput.value;
const winLenInput = document.getElementById('winLength');
let winLen = winLenInput.value;
const boardSizeLabel = document.getElementById('boardSizeLabel');
const winLengthLabel = document.getElementById('winLengthLabel');
const restartButton = document.getElementById('restartButton');
let oTurn;
let cell_size = (220 - (Math.max(boardWidth, boardHeight) * 12));;

startGame();

restartButton.addEventListener('click', function() {
    // Every time the button is clicked, update all the values for the game settings
    boardWidth = boardWidthInput.value;
    boardHeight = boardHeightInput.value;
    winLen = winLenInput.value;
    // Change the cell width when the game is restarted (NOT when the settings are changed or it looks weird)
    document.documentElement.style.setProperty("--cell-size", cell_size + 'px');

    redoDivs(boardWidth, boardHeight);
    
    winningMessageElement.classList.remove('show');
    restartButton.innerText = 'Restart'
    startGame();
});


function startGame() {
    oTurn = false;
    cellElements.forEach(cell => {
        cell.classList.remove(X_class);
        cell.classList.remove(O_class);
        cell.removeEventListener('click', handleClick);
        cell.addEventListener('click', handleClick, { once: true });
    })
    setBoardHoverClass();
}

function handleClick(e) {
    const cell = e.target;
    const currentClass = oTurn ? O_class : X_class
    
    placeMark(cell, currentClass);
    
    if(checkWin(currentClass)) {
        endGame(false)
    } else if (isDraw()) {
        endGame(true)
    } else {
        swapTurns()
        setBoardHoverClass()
    }
}

function updateSettings(elem) {
    if (elem.id == "boardWidth") {
        boardWidth = elem.value;
        updateVals();
    } else if (elem.id == "boardHeight") {
        boardHeight = elem.value;
        updateVals();
    } else if (elem.id == "winLength") {
        winLen = elem.value;
        winLengthLabel.innerText = winLen + '-in-a-row to win';
    }
}
// Exists solely so I don't have to type all this stuff twice in the above function
function updateVals() {
    boardSizeLabel.innerText = 'Board Size: ' + boardWidth + 'x' + boardHeight;
    tempMax = Math.max(boardWidth, boardHeight);
    winLenInput.max = tempMax
    tempMax < winLenInput.value ? winLenInput.value = tempMax : '';
    winLen = winLenInput.value;
    winLengthLabel.innerText = winLen + '-in-a-row to win';
    cell_size = (220 - (tempMax * 15));
}

function endGame(draw) {
    if (draw) {
        winningMessageTxt.innerText = 'Draw!';
    } else {
        winningMessageTxt.innerText = `${oTurn ? "O\'s" : "X\'s"} Win!`
    }
    winningMessageElement.classList.add('show');
}

function isDraw() {
    return [...cellElements].every(cell => {
        return cell.classList.contains(X_class) || cell.classList.contains(O_class)
    })
}

function placeMark(cell, currentClass) {
    cell.classList.add(currentClass)
}

function swapTurns() {
    oTurn = !oTurn;
}

function setBoardHoverClass() {
    board.classList.remove(X_class)
    board.classList.remove(O_class)
    if (oTurn) {
        board.classList.add(O_class)
    } else {
        board.classList.add(X_class)
    }
}

function checkWin(currentClass) {
    let WINNING_COMBINATIONS = generateWinArray(boardWidth, boardHeight, winLen);
        return WINNING_COMBINATIONS.some(combination => {
            return combination.every(index => {
                return cellElements[index].classList.contains(currentClass);
            });
        });
}

function redoDivs(width, height) {
    // Delete all current divs in the board, recreate as many as specified then re-fill the array
    board.innerHTML = '';
    board.className = "";
    for(i = 0; i < width * height; i++) {
        board.innerHTML += '<div class="cell" data-cell></div>';
    }
    cellElements = document.querySelectorAll('[data-cell]');
    // Change the styling to match the number of divs
    board.classList.add('board', 'board' + width + 'wide');
} 